import { InjectionToken } from '@angular/core';

import { AppConfig, AppType } from './types';

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
export const APP_TYPE = new InjectionToken<AppType>('APP_TYPE');
export const APP_VERSION = new InjectionToken<AppType>('APP_VERSION');
